import React, {useEffect} from "react";
import GlobalStyles from 'styles/GlobalStyles';
import {BrowserRouter as Router, Routes, Route, useLocation} from "react-router-dom";
import MainLandingPage from "demos/AgencyLandingPage.js";
import ContactUs from "pages/ContactUs.js";
import BlogIndex from "./pages/BlogIndex";
import BlogPage from "./components/blogs/BlogPage";
import Zakelijk from "./pages/Zakelijk";
//TODO helmet-react for seo head tags!
function CanonicalLinkUpdater() {
    const location = useLocation();

    useEffect(() => {
        const canonicalLink = document.createElement("link");
        canonicalLink.rel = "canonical";

        canonicalLink.href = `https://keyservice247.nl${location.pathname}`;

        const existingCanonical = document.head.querySelector('link[rel="canonical"]');
        if (existingCanonical) {
            existingCanonical.href = canonicalLink.href;
        } else {
            document.head.appendChild(canonicalLink);
        }

        return () => {
            const toRemove = document.head.querySelector('link[rel="canonical"]');
            if (toRemove) {
                document.head.removeChild(toRemove);
            }
        };
    }, [location.pathname]);

    return null;
}

export default function App() {
    return (
        <>
            <GlobalStyles />
            <Router>
                <CanonicalLinkUpdater />
                <Routes>
                    <Route path="/" element={<MainLandingPage />} />
                    <Route path="/offerte-aanvragen" element={<ContactUs />} />
                    <Route path="/blogs" element={<BlogIndex />} />
                    <Route path="/zakelijk" element={<Zakelijk />} />
                    <Route path="/blogs/:slug" element={<BlogPage />} />
                </Routes>
            </Router>
        </>
    );
}
